<template>
	<div class="col-md-10 content">
		<div class="order-history-details">
			<div class="row">
				<div class="col-md-6 order-info">

					<div class="order-info-wrapper">
						<p><strong>Email:</strong> {{ order.email }}</p>
						<p><strong>Name:</strong> {{ order.name }}</p>
						<p><strong>Address:</strong> {{ order.address }}</p>
						<p><strong>City:</strong> {{ order.town }}</p>
						<p><strong>Postal code:</strong> {{ order.post }}</p>
						<p><strong>Country/Region:</strong> {{ order.country}}</p>
						<p><strong>Phone:</strong> {{ order.phone }}</p>
					</div>

					<div class="links">
						<a href="#" title="Return to history" class="link link-arrow-left" @click.prevent="back()"><svg class="ticon"><use xlink:href="/images/icons.svg#icon-chevron-left"></use></svg> Return to history</a>
<!--						<a :href="`/profile/order/invoice/${order.uuid}`" title="Print invoice" class="btn btn-primary btn-lg">Print invoice</a>-->
					</div>
				</div>
				<div class="col-md-6 order-cart">
					<h2 class="h5 h-alter" v-text="$__('order.bag.contents')"></h2>

					<table class="table cart-table">
						<tbody>
						<tr v-for="(product, index) in order.details" :key="product.id">
							<td class="cart-table--picture"></td>
							<td class="cart-table--title">
								<div class="row">
									<div class="col-9 title">
										<h6 v-text="product.product_title"></h6>
										<span class="price-per-item">Price per item:
															<span>{{ product.product_price | formatCurrency }}</span>
														</span>
										<span class="category" v-text=""></span>
									</div>
									<div class="col-auto ml-auto prices">
										<span class="price-sum">{{ product.amount * product.product_price | formatCurrency }}</span>
									</div>
								</div>
							</td>
						</tr>

						</tbody>
						<tfoot>
<!--						<tr class="totals&#45;&#45;subtotal-wrapper">-->
<!--							<td colspan="2">-->
<!--								<div class="totals&#45;&#45;subtotal">-->
<!--									<span>Skupaj brez DDV</span>-->
<!--									<span>$ 492.0</span>-->
<!--								</div>-->
<!--							</td>-->
<!--						</tr>-->
						<tr class="totals--total-wrapper">
							<td colspan="2">
								<div class="totals--total">
									<span v-text="$__('order.text.total')"></span>
									<span>{{ order.order_sum | formatCurrency }}</span>
								</div>
							</td>
						</tr>
						</tfoot>
					</table>

					<div class="links">
						<a href="/shop" :title="$__('order.text.continue.shopping')" v-text="$__('order.text.continue.shopping')"></a>
						<a href="#" :title="$__('order.text.order.again')" class="btn btn-primary btn-lg" v-text="$__('order.text.order.again')" @click.prevent="orderAgain(order)"></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "OrderSingle",
	props: {
		order: Object
	},
	methods: {
		back() {
			this.$emit('closeOrder');
		},
		orderAgain(order) {
			this.$emit('orderAgain', order);
		},
		invoice() {
		}
	}
}
</script>
